import { Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-title',
  imports: [MatIconModule, RouterModule],
  templateUrl: './title.component.html',
  styleUrl: './title.component.css',
})
export class TitleComponent {
  title = input<string>();
  subtitle = input<string>();
  backUrl = input<string>();
  backText = input<string>();
}
